module.exports = __webpack_public_path__ + "static/media/home1.cbaa76b0.jpg";